/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetOrganizationTrialResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * PLGTrialAPIApi - axios parameter creator
 * @export
 */
export const PLGTrialAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GetOrganizationTrial retrieves the PLG trial information for the organization.
         * @summary Get PLG trial information for an organization.
         * @param {string} organizationId organization_id is the UUID of the organization to retrieve trial info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIGetOrganizationTrial: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('pLGTrialAPIGetOrganizationTrial', 'organizationId', organizationId)
            const localVarPath = `/organization-management/v1/organizations/{organizationId}/trials`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * MarkSalesContactedOrganizationTrial marks that sales was contacted for the organization trial,  which prolongs the trial period.
         * @summary Mark that sales has been contacted for the PLG trial.
         * @param {string} organizationId organization_id is the UUID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIMarkSalesContactedOrganizationTrial: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('pLGTrialAPIMarkSalesContactedOrganizationTrial', 'organizationId', organizationId)
            const localVarPath = `/organization-management/v1/organizations/{organizationId}/trials/sales-contacted`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts the trial for the organization.
         * @param {string} organizationId organization_id is the UUID of the organization to retrieve trial info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIStartOrganizationTrial: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('pLGTrialAPIStartOrganizationTrial', 'organizationId', organizationId)
            const localVarPath = `/organization-management/v1/organizations/{organizationId}/trials/start`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PLGTrialAPIApi - functional programming interface
 * @export
 */
export const PLGTrialAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PLGTrialAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * GetOrganizationTrial retrieves the PLG trial information for the organization.
         * @summary Get PLG trial information for an organization.
         * @param {string} organizationId organization_id is the UUID of the organization to retrieve trial info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pLGTrialAPIGetOrganizationTrial(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationTrialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pLGTrialAPIGetOrganizationTrial(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PLGTrialAPIApi.pLGTrialAPIGetOrganizationTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * MarkSalesContactedOrganizationTrial marks that sales was contacted for the organization trial,  which prolongs the trial period.
         * @summary Mark that sales has been contacted for the PLG trial.
         * @param {string} organizationId organization_id is the UUID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pLGTrialAPIMarkSalesContactedOrganizationTrial(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pLGTrialAPIMarkSalesContactedOrganizationTrial(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PLGTrialAPIApi.pLGTrialAPIMarkSalesContactedOrganizationTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts the trial for the organization.
         * @param {string} organizationId organization_id is the UUID of the organization to retrieve trial info for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pLGTrialAPIStartOrganizationTrial(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pLGTrialAPIStartOrganizationTrial(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PLGTrialAPIApi.pLGTrialAPIStartOrganizationTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PLGTrialAPIApi - factory interface
 * @export
 */
export const PLGTrialAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PLGTrialAPIApiFp(configuration)
    return {
        /**
         * GetOrganizationTrial retrieves the PLG trial information for the organization.
         * @summary Get PLG trial information for an organization.
         * @param {PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIGetOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrganizationTrialResponse> {
            return localVarFp.pLGTrialAPIGetOrganizationTrial(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * MarkSalesContactedOrganizationTrial marks that sales was contacted for the organization trial,  which prolongs the trial period.
         * @summary Mark that sales has been contacted for the PLG trial.
         * @param {PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIMarkSalesContactedOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.pLGTrialAPIMarkSalesContactedOrganizationTrial(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts the trial for the organization.
         * @param {PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pLGTrialAPIStartOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.pLGTrialAPIStartOrganizationTrial(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pLGTrialAPIGetOrganizationTrial operation in PLGTrialAPIApi.
 * @export
 * @interface PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest
 */
export interface PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest {
    /**
     * organization_id is the UUID of the organization to retrieve trial info for.
     * @type {string}
     * @memberof PLGTrialAPIApiPLGTrialAPIGetOrganizationTrial
     */
    readonly organizationId: string
}

/**
 * Request parameters for pLGTrialAPIMarkSalesContactedOrganizationTrial operation in PLGTrialAPIApi.
 * @export
 * @interface PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest
 */
export interface PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest {
    /**
     * organization_id is the UUID of the organization.
     * @type {string}
     * @memberof PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrial
     */
    readonly organizationId: string
}

/**
 * Request parameters for pLGTrialAPIStartOrganizationTrial operation in PLGTrialAPIApi.
 * @export
 * @interface PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest
 */
export interface PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest {
    /**
     * organization_id is the UUID of the organization to retrieve trial info for.
     * @type {string}
     * @memberof PLGTrialAPIApiPLGTrialAPIStartOrganizationTrial
     */
    readonly organizationId: string
}

/**
 * PLGTrialAPIApi - object-oriented interface
 * @export
 * @class PLGTrialAPIApi
 * @extends {BaseAPI}
 */
export class PLGTrialAPIApi extends BaseAPI {
    /**
     * GetOrganizationTrial retrieves the PLG trial information for the organization.
     * @summary Get PLG trial information for an organization.
     * @param {PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PLGTrialAPIApi
     */
    public pLGTrialAPIGetOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIGetOrganizationTrialRequest, options?: RawAxiosRequestConfig) {
        return PLGTrialAPIApiFp(this.configuration).pLGTrialAPIGetOrganizationTrial(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * MarkSalesContactedOrganizationTrial marks that sales was contacted for the organization trial,  which prolongs the trial period.
     * @summary Mark that sales has been contacted for the PLG trial.
     * @param {PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PLGTrialAPIApi
     */
    public pLGTrialAPIMarkSalesContactedOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIMarkSalesContactedOrganizationTrialRequest, options?: RawAxiosRequestConfig) {
        return PLGTrialAPIApiFp(this.configuration).pLGTrialAPIMarkSalesContactedOrganizationTrial(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts the trial for the organization.
     * @param {PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PLGTrialAPIApi
     */
    public pLGTrialAPIStartOrganizationTrial(requestParameters: PLGTrialAPIApiPLGTrialAPIStartOrganizationTrialRequest, options?: RawAxiosRequestConfig) {
        return PLGTrialAPIApiFp(this.configuration).pLGTrialAPIStartOrganizationTrial(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}

